"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetFundraisingEventThankYouDataDocument = exports.GetForwardingFundraisingEventAuthenticatedDocument = exports.GetDonateConfigDocument = exports.GetCurrentUserDocument = exports.FundraisingEventDistributionDocument = exports.DonationProcessDocument = exports.ValidationErrorFieldsFragmentDoc = exports.FundraisingEventThankYouFieldsFragmentDoc = exports.FundraisingEventForwardingFieldsFragmentDoc = exports.FullDonateConfigFieldsFragmentDoc = exports.DonateDisplayFieldsFragmentDoc = exports.MatchingEventFieldsFragmentDoc = exports.MatchingEventModalInfoFieldsFragmentDoc = exports.DonateConfigFieldsFragmentDoc = exports.CurrentUserFieldsFragmentDoc = exports.ReceiverTypes = exports.PaymentMethods = exports.DonationIntervals = exports.DonationConfigWordings = void 0;
var DonationConfigWordings;
(function (DonationConfigWordings) {
    DonationConfigWordings["Formal"] = "FORMAL";
    DonationConfigWordings["Informal"] = "INFORMAL";
    DonationConfigWordings["InformalGeneric"] = "INFORMAL_GENERIC";
})(DonationConfigWordings || (exports.DonationConfigWordings = DonationConfigWordings = {}));
var DonationIntervals;
(function (DonationIntervals) {
    DonationIntervals["Monthly"] = "MONTHLY";
    DonationIntervals["Single"] = "SINGLE";
    DonationIntervals["Yearly"] = "YEARLY";
})(DonationIntervals || (exports.DonationIntervals = DonationIntervals = {}));
var PaymentMethods;
(function (PaymentMethods) {
    PaymentMethods["DirectDeposit"] = "DIRECT_DEPOSIT";
    PaymentMethods["DummyPayment"] = "DUMMY_PAYMENT";
    PaymentMethods["Paypal"] = "PAYPAL";
    PaymentMethods["StripeCc"] = "STRIPE_CC";
    PaymentMethods["StripeGiropay"] = "STRIPE_GIROPAY";
    PaymentMethods["StripeSepaDebit"] = "STRIPE_SEPA_DEBIT";
})(PaymentMethods || (exports.PaymentMethods = PaymentMethods = {}));
var ReceiverTypes;
(function (ReceiverTypes) {
    ReceiverTypes["FundraisingEvent"] = "FUNDRAISING_EVENT";
    ReceiverTypes["Project"] = "PROJECT";
})(ReceiverTypes || (exports.ReceiverTypes = ReceiverTypes = {}));
exports.CurrentUserFieldsFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'CurrentUserFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CurrentUser' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
                ],
            },
        },
    ],
};
exports.DonateConfigFieldsFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'DonateConfigFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'DonateConfig' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'backgroundColor' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'bottomLogo' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'captchaEndpoint' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'captchaSiteKey' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'channel' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'clientName' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'clientReference' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'color' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'countryAlpha2' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'debug' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'defaultDonationCents' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'defaultInterval' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'defaultPaymentMethod' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'donationsProhibited' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'levyPercentage' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'needId' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'paymentMethods' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'paypalClientId' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'receiverId' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'receiverType' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'recurringPaymentMethods' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'showCodonation' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'showDisplayName' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'showFakeButtons' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'showMatchingEvent' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'showMatchingFund' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'showMessageField' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'showMonthlyMatching' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'showPlatformSubscription' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'showRecurring' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'stripePublicKey' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'submitUrl' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'trackingChannel' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'trackingVia' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'wording' } },
                ],
            },
        },
    ],
};
exports.MatchingEventModalInfoFieldsFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'MatchingEventModalInfoFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'MatchingEventModalInfo' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'budget' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'extraInfo' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'furtherInfo' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'headline' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'maximumAmount' } },
                ],
            },
        },
    ],
};
exports.MatchingEventFieldsFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'MatchingEventFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'MatchingEventBanner' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'backgroundColor' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'bannerContent' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'branchLogo' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'color' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'logo' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'providedAmountInCents' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'modalInfo' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'MatchingEventModalInfoFields' } }],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'MatchingEventModalInfoFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'MatchingEventModalInfo' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'budget' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'extraInfo' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'furtherInfo' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'headline' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'maximumAmount' } },
                ],
            },
        },
    ],
};
exports.DonateDisplayFieldsFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'DonateDisplayFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'DonateDisplay' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'carrierCity' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'carrierCountry' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'carrierName' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'carrierProfilePicture' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'carrierStreet' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'carrierZip' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'layout' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'makerImageUrl' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'makerKind' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'makerName' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'matchingEvent' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'MatchingEventFields' } }],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'matchingFundCompanyName' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'matchingFundLimitCents' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'receiverGtmBrand' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'receiverName' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'receiverProfilePicture' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'receiverUrl' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'transactionCostNotice' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'ultimatelySubjectToLevy' } },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'MatchingEventModalInfoFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'MatchingEventModalInfo' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'budget' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'extraInfo' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'furtherInfo' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'headline' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'maximumAmount' } },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'MatchingEventFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'MatchingEventBanner' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'backgroundColor' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'bannerContent' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'branchLogo' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'color' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'logo' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'providedAmountInCents' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'modalInfo' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'MatchingEventModalInfoFields' } }],
                        },
                    },
                ],
            },
        },
    ],
};
exports.FullDonateConfigFieldsFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'FullDonateConfigFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FullDonateConfig' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'donateConfig' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'DonateConfigFields' } }],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'donateDisplay' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'DonateDisplayFields' } }],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'wirwunderWhiteLogoURL' } },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'MatchingEventModalInfoFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'MatchingEventModalInfo' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'budget' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'extraInfo' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'furtherInfo' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'headline' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'maximumAmount' } },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'MatchingEventFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'MatchingEventBanner' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'backgroundColor' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'bannerContent' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'branchLogo' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'color' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'logo' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'providedAmountInCents' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'modalInfo' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'MatchingEventModalInfoFields' } }],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'DonateConfigFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'DonateConfig' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'backgroundColor' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'bottomLogo' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'captchaEndpoint' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'captchaSiteKey' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'channel' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'clientName' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'clientReference' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'color' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'countryAlpha2' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'debug' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'defaultDonationCents' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'defaultInterval' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'defaultPaymentMethod' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'donationsProhibited' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'levyPercentage' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'needId' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'paymentMethods' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'paypalClientId' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'receiverId' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'receiverType' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'recurringPaymentMethods' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'showCodonation' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'showDisplayName' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'showFakeButtons' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'showMatchingEvent' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'showMatchingFund' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'showMessageField' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'showMonthlyMatching' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'showPlatformSubscription' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'showRecurring' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'stripePublicKey' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'submitUrl' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'trackingChannel' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'trackingVia' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'wording' } },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'DonateDisplayFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'DonateDisplay' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'carrierCity' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'carrierCountry' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'carrierName' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'carrierProfilePicture' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'carrierStreet' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'carrierZip' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'layout' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'makerImageUrl' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'makerKind' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'makerName' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'matchingEvent' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'MatchingEventFields' } }],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'matchingFundCompanyName' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'matchingFundLimitCents' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'receiverGtmBrand' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'receiverName' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'receiverProfilePicture' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'receiverUrl' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'transactionCostNotice' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'ultimatelySubjectToLevy' } },
                ],
            },
        },
    ],
};
exports.FundraisingEventForwardingFieldsFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'FundraisingEventForwardingFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FundraisingEvent' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'receivedAmountInCents' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'forwardedAmountInCents' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'balanceAmountInCents' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'forwardingsPerProject' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'amountInCents' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'project' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'outstandingAmountInCents' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'canReceiveDonations' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'title' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'de' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'en' } },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
exports.FundraisingEventThankYouFieldsFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'FundraisingEventThankYouFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FundraisingEvent' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'publicFace' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'imageUrl100x100' } },
                            ],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'donorCount' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'forwardings' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'ids' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'donationIds' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'amountInCents' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'receiver' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                            {
                                                kind: 'InlineFragment',
                                                typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Project' } },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'title' },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    { kind: 'Field', name: { kind: 'Name', value: 'de' } },
                                                                    { kind: 'Field', name: { kind: 'Name', value: 'en' } },
                                                                ],
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sponsor' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'imageUrl420x230' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
exports.ValidationErrorFieldsFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ValidationErrorFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ValidationError' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fieldErrors' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'errorType' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
exports.DonationProcessDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'DonationProcess' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'clientId' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'donationProcessInput' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'DonationProcessInput' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'donationProcess' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'input' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'clientMutationId' },
                                            value: { kind: 'Variable', name: { kind: 'Name', value: 'clientId' } },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'donationProcessInput' },
                                            value: { kind: 'Variable', name: { kind: 'Name', value: 'donationProcessInput' } },
                                        },
                                    ],
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'donationProcessResult' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                            {
                                                kind: 'InlineFragment',
                                                typeCondition: {
                                                    kind: 'NamedType',
                                                    name: { kind: 'Name', value: 'DonationProcessSuccessResult' },
                                                },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'redirectTo' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'paypalToken' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'stripePaymentIntentClientSecret' } },
                                                    ],
                                                },
                                            },
                                            {
                                                kind: 'InlineFragment',
                                                typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ValidationError' } },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ValidationErrorFields' } },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ValidationErrorFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ValidationError' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fieldErrors' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'errorType' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
exports.FundraisingEventDistributionDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'FundraisingEventDistribution' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'fundraisingEventId' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'clientId' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'distribution' } },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'ListType',
                            type: {
                                kind: 'NonNullType',
                                type: { kind: 'NamedType', name: { kind: 'Name', value: 'FundraisingEventDistributionInput' } },
                            },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fundraisingEventDistributionCreate' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'input' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'clientMutationId' },
                                            value: { kind: 'Variable', name: { kind: 'Name', value: 'clientId' } },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'fundraisingEvent' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: 'id' },
                                                        value: { kind: 'Variable', name: { kind: 'Name', value: 'fundraisingEventId' } },
                                                    },
                                                ],
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'fundraisingEventDistributionInput' },
                                            value: { kind: 'Variable', name: { kind: 'Name', value: 'distribution' } },
                                        },
                                    ],
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'clientMutationId' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'forwardingResult' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                            {
                                                kind: 'InlineFragment',
                                                typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ForwardingResult' } },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'fundraisingEvent' },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'forwardings' },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                            {
                                                kind: 'InlineFragment',
                                                typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ValidationError' } },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ValidationErrorFields' } },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ValidationErrorFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ValidationError' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fieldErrors' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'errorType' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
exports.GetCurrentUserDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'GetCurrentUser' },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'currentUser' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CurrentUserFields' } }],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'CurrentUserFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CurrentUser' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
                ],
            },
        },
    ],
};
exports.GetDonateConfigDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'GetDonateConfig' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'channel' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'receiverType' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'receiverId' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fullDonateConfig' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'channel' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'channel' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'receiverType' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'receiverType' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'receiverId' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'receiverId' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'locale' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'FullDonateConfigFields' } }],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'DonateConfigFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'DonateConfig' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'backgroundColor' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'bottomLogo' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'captchaEndpoint' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'captchaSiteKey' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'channel' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'clientName' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'clientReference' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'color' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'countryAlpha2' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'debug' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'defaultDonationCents' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'defaultInterval' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'defaultPaymentMethod' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'donationsProhibited' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'levyPercentage' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'needId' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'paymentMethods' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'paypalClientId' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'receiverId' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'receiverType' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'recurringPaymentMethods' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'showCodonation' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'showDisplayName' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'showFakeButtons' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'showMatchingEvent' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'showMatchingFund' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'showMessageField' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'showMonthlyMatching' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'showPlatformSubscription' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'showRecurring' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'stripePublicKey' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'submitUrl' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'trackingChannel' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'trackingVia' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'wording' } },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'MatchingEventModalInfoFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'MatchingEventModalInfo' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'budget' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'extraInfo' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'furtherInfo' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'headline' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'maximumAmount' } },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'MatchingEventFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'MatchingEventBanner' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'backgroundColor' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'bannerContent' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'branchLogo' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'color' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'logo' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'providedAmountInCents' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'modalInfo' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'MatchingEventModalInfoFields' } }],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'DonateDisplayFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'DonateDisplay' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'carrierCity' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'carrierCountry' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'carrierName' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'carrierProfilePicture' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'carrierStreet' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'carrierZip' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'layout' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'makerImageUrl' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'makerKind' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'makerName' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'matchingEvent' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'MatchingEventFields' } }],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'matchingFundCompanyName' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'matchingFundLimitCents' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'receiverGtmBrand' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'receiverName' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'receiverProfilePicture' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'receiverUrl' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'transactionCostNotice' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'ultimatelySubjectToLevy' } },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'FullDonateConfigFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FullDonateConfig' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'donateConfig' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'DonateConfigFields' } }],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'donateDisplay' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'DonateDisplayFields' } }],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'wirwunderWhiteLogoURL' } },
                ],
            },
        },
    ],
};
exports.GetForwardingFundraisingEventAuthenticatedDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'GetForwardingFundraisingEventAuthenticated' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fundraisingEvent' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'id' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'FundraisingEventForwardingFields' } },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'FundraisingEventForwardingFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FundraisingEvent' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'receivedAmountInCents' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'forwardedAmountInCents' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'balanceAmountInCents' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'forwardingsPerProject' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'amountInCents' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'project' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'outstandingAmountInCents' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'canReceiveDonations' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'title' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'de' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'en' } },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
exports.GetFundraisingEventThankYouDataDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'GetFundraisingEventThankYouData' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'donationIds' } },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'ListType',
                            type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fundraisingEvent' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'id' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'FundraisingEventThankYouFields' } }],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'FundraisingEventThankYouFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FundraisingEvent' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'publicFace' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'imageUrl100x100' } },
                            ],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'donorCount' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'forwardings' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'ids' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'donationIds' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'amountInCents' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'receiver' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                            {
                                                kind: 'InlineFragment',
                                                typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Project' } },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'title' },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    { kind: 'Field', name: { kind: 'Name', value: 'de' } },
                                                                    { kind: 'Field', name: { kind: 'Name', value: 'en' } },
                                                                ],
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sponsor' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'imageUrl420x230' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
//# sourceMappingURL=graphql.js.map